//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import contactMixin from '../mixin/contact'
export default {
    mixins: [contactMixin],
    data () {
        return {
            qr: 'https://cdn.vip-wifi.com/fangchan/img/cooperation/service-qr.png'
        }
    },
    onShareAppMessage () {
        const sub_page = encodeURIComponent('/pages/packageA/contact_us/service/main')
        return this.getShareInfo({
            title: `联系客服`,
            path: `/pages/index/main?sub_page=${sub_page}`
        })
    }
}
